import React from "react";


const bookedCar = (props) => {
  return (
    <div>
    
        <img src={props.img} alt="car-image" />
     
    </div>
  );
};

export default bookedCar;
